export const CUSTOMER_SEARCH_REQUEST = 'SWITCH_ACCOUNT_CUSTOMER_SEARCH_REQUEST';
export const CUSTOMER_SEARCH_SUCCESS = 'SWITCH_ACCOUNT_CUSTOMER_SEARCH_SUCCESS';
export const CUSTOMER_SEARCH_FAIL = 'SWITCH_ACCOUNT_CUSTOMER_SEARCH_FAIL';
export const CLEAR_SWITCH_ACCOUNTS = 'SWITCH_ACCOUNT_CUSTOMER_CLEAR';
